import React from 'react';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';

const OfflineBanner = ({ isOnline, onRetry, queueCount = 0 }) => {
  if (isOnline && queueCount === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '56px',
      left: 0,
      right: 0,
      zIndex: 99999,
      opacity: 1,
      backgroundColor: isOnline ? '#22c55e' : '#ef4444',
      color: 'white'
    }} className="shadow-lg">
      <div className="max-w-6xl mx-auto px-4 py-2">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            {isOnline ? (
              <>
                <Wifi size={20} className="animate-pulse" />
                <div>
                  <p className="font-semibold text-sm">✅ Wieder online!</p>
                  {queueCount > 0 && (
                    <p className="text-xs opacity-90">
                      {queueCount} ausstehende Aktion{queueCount > 1 ? 'en' : ''} wird synchronisiert...
                    </p>
                  )}
                </div>
              </>
            ) : (
              <>
                <WifiOff size={20} />
                <div>
                  <p className="font-semibold text-sm">⚠️ Offline-Modus</p>
                  <p className="text-xs opacity-90">
                    Änderungen werden gespeichert und später synchronisiert
                  </p>
                </div>
              </>
            )}
          </div>
          
          {!isOnline && onRetry && (
            <button
              onClick={onRetry}
              className="flex items-center gap-2 bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-1.5 rounded-lg text-sm font-semibold transition-all"
            >
              <RefreshCw size={16} />
              <span className="hidden sm:inline">Neu versuchen</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfflineBanner;
